import React from 'react'
import { J2Multiply } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Card, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  vehicleCardHeadline: {
    textAlign: 'center',
  },
  centeredIcon: {
    marginTop: theme.spacing(4),
    display: 'flex',
    height: '60px',
    width: '60px',
  },
  buttonBox: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
    },
  },
}))

interface Props {
  retryToConnect: () => Promise<void>
  handleBackButtonClick: () => void
}

/**
 * Represents the "connection failed"-screen when trying to connect your vehicle to your power station
 */
const ConnectionFailed: React.VFC<Props> = ({ retryToConnect, handleBackButtonClick }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <J2Multiply color="error" className={classes.centeredIcon} />
      </Box>
      <Typography variant="h2" className={classes.vehicleCardHeadline}>
        {t('emobility.vehicle-integration.connection-failed')}
      </Typography>
      <Box className={classes.buttonBox}>
        <Button onClick={handleBackButtonClick}>{t('emobility.vehicle-integration.cancel-connection')}</Button>
        <Button variant="contained" onClick={retryToConnect}>
          {t('emobility.vehicle-integration.retry-connection')}
        </Button>
      </Box>
    </Card>
  )
}

export default ConnectionFailed
